import React, { useEffect, useState } from "react";
import milkTubLogo from "../pages/utils/images/milktub-logo.svg";
import "./stressQuiz.css";
import toast from "react-hot-toast";
import { Button } from "@mui/material";

const StressQuiz = () => {
  const [submitting, setSubmitting] = useState(false);
  function formValidation(event) {
    event.preventDefault();
    setSubmitting(true);

    const formData = new FormData(this);
    fetch(
      "https://script.google.com/macros/s/AKfycbxJKii9WIeax0zBhXtfvYqSW0U2P4kl2kCIEpwX6wNlxcOrfMDxrrsi75lxVJBq_iXY6A/exec",
      {
        method: "POST",
        body: formData,
      }
    )
      .then((response) => response.text())
      .then((data) => {
        // document.getElementById("quizForm").reset();

        // Determine stress score
        let scoreMapping = { A: 1, B: 2, C: 3, D: 3 };
        let totalScore =
          scoreMapping[formData.get("q1")] +
          scoreMapping[formData.get("q2")] +
          scoreMapping[formData.get("q3")] +
          scoreMapping[formData.get("q4")];

        let stressLevel, gifUrl;

        if (totalScore <= 6) {
          stressLevel = "🟢 Chill Mode (Low Stress)";
          gifUrl = "https://media.giphy.com/media/l0HUqsz2jdQYElRm0/giphy.gif";
        } else if (totalScore <= 9) {
          stressLevel = "🟡 Mild Panic (Medium Stress)";
          gifUrl = "https://media.giphy.com/media/3o7abKhOpu0NwenH3O/giphy.gif";
        } else {
          stressLevel = "🔴 Total Overload (High Stress)";
          gifUrl =
            "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExdjA2OWozOGRoc3o4Ym9nM3VodXRtOXY3bXp5bDlobmY2dGxxb2ZjbiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/l3dj0GFYLf0z7WSCQ/giphy.gif";
        }

        let inputUrl = formData.get("website");

        if (!inputUrl) {
          toast.error("Website URL is required.");
          setSubmitting(false);
          return;
        }

        if (
          !inputUrl.startsWith("http://") &&
          !inputUrl.startsWith("https://")
        ) {
          inputUrl = "http://" + inputUrl;
        }

        const urlPattern = new RegExp(
          "^(https?:\\/\\/)?" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // domain name
            "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
            "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
            "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$",
          "i" // fragment locator
        );

        if (!urlPattern.test(inputUrl)) {
          toast.error("Please enter a valid URL.");
          setSubmitting(false);
          return;
        }

        window.location.href = `/start_audit?mail=${formData.get(
          "email"
        )}&url=${inputUrl}&totalScore=${totalScore}&stressLevel=${stressLevel}&gifUrl=${gifUrl}`;
      })
      .catch((error) => {
        console.error("Error:", error);
        setSubmitting(false);
      });
  }

  useEffect(() => {
    document
      .getElementById("quizForm")
      .addEventListener("submit", formValidation);
  }, []);

  return (
    <div className="quiz">
      <div className="quiz-container">
        <img src={milkTubLogo} alt="Milktub Logo" className="quiz-logo" />
        <h1 className="quiz-h1">Check Your E-Commerce Stress Levels</h1>
        <p className="quiz-para">
          Complete this quick quiz to see how stressed your Shopify store is!
        </p>

        <form
          id="quizForm"
          action="https://script.google.com/macros/s/AKfycbxJKii9WIeax0zBhXtfvYqSW0U2P4kl2kCIEpwX6wNlxcOrfMDxrrsi75lxVJBq_iXY6A/exec"
          method="POST"
        >
          <div className="quiz-question">
            <label>First Name:</label>
            <input
              className="quiz-input"
              type="text"
              name="firstName"
              required
            />
          </div>
          <div className="quiz-question">
            <label>Last Name:</label>
            <input
              className="quiz-input"
              type="text"
              name="lastName"
              required
            />
          </div>
          <div className="quiz-question">
            <label>Company:</label>
            <input className="quiz-input" type="text" name="company" required />
          </div>
          <div className="quiz-question">
            <label>Position:</label>
            <input
              className="quiz-input"
              type="text"
              name="position"
              required
            />
          </div>
          <div className="quiz-question">
            <label>Email:</label>
            <input
              className="quiz-input"
              type="email"
              name="email"
              id="email"
              required
            />
            <p id="emailError" style={{ color: "red", display: "none" }}>
              Please enter a valid email address.
            </p>
          </div>
          <div className="quiz-question">
            <label>Website URL (for audit):</label>
            <input
              className="quiz-input"
              type="text"
              name="website"
              id="website"
              placeholder="https://"
              required
            />
          </div>

          <div className="quiz-question">
            <p>1. How do you feel about your Shopify store’s performance?</p>
            <select className="quiz-select" name="q1" required>
              <option value="A">It’s thriving! I just want to scale 🚀</option>
              <option value="B">
                It’s okay, but conversions could be better 🤷‍♂️
              </option>
              <option value="C">
                It’s stressful—ads aren’t working, traffic isn’t converting 😩
              </option>
              <option value="D">
                I have no idea what’s happening. Help. 🆘
              </option>
            </select>
          </div>
          <div className="quiz-question">
            <p>
              2. What’s your biggest challenge when it comes to growing sales?
            </p>
            <select className="quiz-select" name="q2" required>
              <option value="A">
                Not getting enough high-quality traffic 😕
              </option>
              <option value="B">People visit but don’t buy 🛒</option>
              <option value="C">
                Ads are expensive and don’t bring in returns 📉
              </option>
              <option value="D">I don’t even know where to start 😵</option>
            </select>
          </div>
          <div className="quiz-question">
            <p>3. How do you track what’s working on your site?</p>
            <select className="quiz-select" name="q3" required>
              <option value="A">
                I check Shopify analytics & ad dashboards daily 📊
              </option>
              <option value="B">
                I look at them sometimes but don’t fully get the data 🤔
              </option>
              <option value="C">I just guess and hope for the best 😅</option>
              <option value="D">What tracking? 😳</option>
            </select>
          </div>
          <div className="quiz-question">
            <p>
              4. If you could wave a magic wand and fix one thing in your store
              today, what would it be?
            </p>
            <select className="quiz-select" name="q4" required>
              <option value="A">Get more profitable traffic 🚦</option>
              <option value="B">Improve conversion rates 🔥</option>
              <option value="C">Make my site run faster & smoother ⚡</option>
              <option value="D">
                Automate all the annoying marketing stuff 🤖
              </option>
            </select>
          </div>

          <Button
            disabled={submitting}
            sx={{
              bgcolor: "#0056b3",
              color: "white",
              marginTop: "20px",
              width: "100%",
              fontSize: "16px",
              "&:hover": {
                bgcolor: "#004080",
              },
              "&:disabled": {
                bgcolor: "#DAE2ED",
                color: "#434D5B",
                cursor: "not-allowed",
              },
            }}
            color="primary"
            type="submit"
          >
            See Your Stress Score and Start The Audit
          </Button>
        </form>
        {/* <p id="successMessage" className="quiz-hidden"></p>
        <div id="gifContainer" className="quiz-gif-container quiz-hidden"></div> */}
      </div>
    </div>
  );
};

export default StressQuiz;
